import { render, staticRenderFns } from "./ExtraFieldRow.vue?vue&type=template&id=d51671b0&scoped=true"
import script from "./ExtraFieldRow.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldRow.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldRow.vue?vue&type=style&index=0&id=d51671b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51671b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d51671b0')) {
      api.createRecord('d51671b0', component.options)
    } else {
      api.reload('d51671b0', component.options)
    }
    module.hot.accept("./ExtraFieldRow.vue?vue&type=template&id=d51671b0&scoped=true", function () {
      api.rerender('d51671b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldRow.vue"
export default component.exports